/* jshint esversion: 6 */
import React from 'react';
import UncontrolledTextInput from 'app/components/common/UncontrolledTextInput.jsx';
import * as _ from 'underscore';
import MediaUploader from 'app/components/PostingTool/MediaUploader.js';

class GalleryChooser extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            search: '',
            page: 0,
            observer: null,
            errors: [],
            isBusy: false,
        };

        this.requestMedia = this.requestMedia.bind(this);
        this.registerObserver = this.registerObserver.bind(this);
        this.observerCallback = this.observerCallback.bind(this);
        this.lastImageRef = React.createRef();
        this.searchTrigger = this.searchTrigger.bind(this);
        this.keyListener = this.keyListener.bind(this);
        this.onMediaSelection = this.onMediaSelection.bind(this);

        this.debouncedSearchTrigger = _.debounce(this.searchTrigger, 1000);

    }

    componentDidMount() {

        // fire off the default request
        this.requestMedia();

        window.addEventListener('keyup', this.keyListener);

    }

    componentWillUnmount() {
        if (this.state.observer !== null) {
            this.state.observer.disconnect();
        }

        window.removeEventListener('keyup', this.keyListener);

    }

    requestMedia() {
        let page = this.state.page + 1;

        this.props.getMediaGallery({
            pageID: page,
            searchTerm: this.state.search
        });

        this.setState({
            page
        });
    }

    registerObserver() {

        if (this.state.observer !== null) {
            this.state.observer.disconnect();
        }

        if (this.lastImageRef.current) {
            let observer = new IntersectionObserver(this.observerCallback, {
                threshold: 0.5
            });

            observer.observe(this.lastImageRef.current);

            this.setState({
                observer
            });
        }

    }

    observerCallback(entries, observer) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                this.state.observer.disconnect();
                this.setState({
                    observer: null
                });
                this.requestMedia();
            }
        });
    }

    searchTrigger() {
        // reset the page count so the new search results
        // replace the existing ones
        this.setState({
            page: 0
        }, () => {
            this.requestMedia();
        });
    }

    keyListener(e) {
        if (e.keyCode === 13) {
            this.searchTrigger();
        }
    }

    onMediaSelection(media) {
        if (this.state.isBusy) {
            return;
        }

        this.setState({
            isBusy: true
        }, () => {
            let formData = new FormData;
            formData.append('type', 'postMedia');
            formData.append('mediaId', media.id);
            formData.append('mediaSource', 'unsplash');

            MediaUploader({
                formData,
                onUploadProgress: (progress) => {},
                responseCallback: (response) => {
                    let data = response.data;

                    // hardcode for now, but set the service up in the return data
                    // in case of attribution required or other post attachment necessities
                    data.unsplashData = {
                        username: media.username
                    };

                    if (this.props.accessoryServiceId !== undefined) {
                        this.props.attachMedia(data, this.props.accessoryServiceId);
                    } else {
                        this.props.attachMedia(data);
                    }

                    if (data.val_result !== undefined && data.val_result.payload !== undefined) {
                        if (Object.keys(data.val_result.payload).length) {
                            this.props.updateMediaErrors(data.val_result.payload);
                        }
                    } else {
                        if (this.props.accessoryServiceId !== undefined) {
                            this.props.clearMediaErrors([this.props.accessoryServiceId]);
                        }
                    }
                    this.props.cancelAction();
                },
                errorCallback: (error) => {
                    if (error.response) {
                        let errorData = error.response.data.errors || null,
                            errorMsgs = [];

                        const extractErrors = (obj) => {
                            if (Object.keys(obj).length) {
                                Object.keys(obj).map((key) => {
                                    if (typeof obj[key] === 'string') {
                                        errorMsgs.push(obj[key]);
                                    } else if (Object.keys(obj[key])) {
                                        extractErrors(obj[key]);
                                    }
                                });
                            }
                        };

                        // session died before upload
                        if (error.response.status === 403) {
                            window.location.reload();
                            return;
                        }

                        if (error.response.status === 413) {
                            this.props.updateMediaErrors(mediaError);
                            this.props.cancelAction();
                            return;
                        }

                        extractErrors(errorData);

                        if (errorMsgs.length) {
                            if (this.props.accessoryServiceId !== undefined) {
                                let mediaError = {};
                                mediaError[this.props.accessoryServiceId] = errorMsgs.join(" ");
                                this.props.updateMediaErrors(mediaError);
                                this.props.cancelAction();
                            } else {
                                this.setState({
                                    errors: errorMsgs.join(" ")
                                });
                            }
                        }
                    } else if (error.message) {
                        if (this.props.accessoryServiceId !== undefined) {
                            let mediaError = {};
                            mediaError[this.props.accessoryServiceId] = error.message;
                            this.props.updateMediaErrors(mediaError);
                            this.props.cancelAction();
                        } else {
                            this.setState({
                                errors: error.message
                            });
                        }
                    }

                }
            });
        });


    }

    render() {
        let imgPath = this.props.app.config.assetsUrl + "/" + this.props.app.config.imageUrl,
            errors = null;

        if (this.state.errors.length) {
            errors = (
                <div className="instruction-error">
                    {this.state.errors}
                </div>
            );
        }

        return (
            <div className="pt-gallery-chooser">
                <div className="gallery-search">
                    <div className="service-logo">
                        <img width="125" height="auto" src={imgPath + "/svg-logos/unsplash.svg"}/>
                    </div>
                    {errors}
                    <div className="search-bar">
                        <div className="search-button" onClick={() => {
                            this.setState({
                                page: 0
                            }, () => {
                                this.requestMedia()
                            });
                        }}>
                            <i className="fa fa-search"/>
                        </div>
                        <UncontrolledTextInput
                             className="text-input gallery-search"
                             onChange={(e) => {
                                this.setState({
                                    search: e.currentTarget.value
                                }, () => {
                                    this.debouncedSearchTrigger();
                                });
                             }}/>
                    </div>
                </div>
                <div className="gallery-results" ref={this.galleryRef}>
                    {this.props.posts.mediaGallery.media.map((media, i) => {
                        let ref = null,
                            onLoad = () => {},
                            constants = this.props.app.config.constants;

                        if (i === this.props.posts.mediaGallery.media.length - 1) {
                            ref = this.lastImageRef;
                            onLoad = this.registerObserver;
                        }

                        return (
                            <div key={media.id} ref={ref} className="gallery-entry">
                                <div className="gallery-image" onClick={(e) => {
                                    this.onMediaSelection(media);
                                }}>
                                    <img src={media.thumb} onLoad={onLoad}/>
                                </div>
                                <div className="attribution">
                                    Photo by <a href={`${media.unsplash_link}`} target="_blank">{media.username}</a> on <a href={`https://unsplash.com/?utm_source=${constants.UNSPLASH_UTM_SOURCE}&utm_medium=referral`} target="_blank">Unsplash</a>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}

GalleryChooser.displayName = "GalleryChooser";

export default GalleryChooser;
